<template>

    <b-container class="sorting-container">

		<draggable v-model="valueTemp"
				   group="entities"
				   v-bind="{handle:'.handle', animation:150}">

			<b-container v-for="(item, index) in valueTemp"
						 :key="'policy_' + index"
						 class="sorting-entity-container">

				<b-row class="sorting-entity-row">

					<b-col cols="7" class="pr-15">
						<custom-multiselect v-model="valueTemp[index]"
											:options="options" />
					</b-col>

					<b-col class="p-0-5">
						<b-button block
								  :disabled="item == null"
								  class="draggable-button green" 
                              	  @click="openEntity(item)">
							Открыть
						</b-button>
					</b-col>

					<b-col>
						<b-button block class="draggable-button red" @click="deleteEntity(index)">
							Удалить
						</b-button>
					</b-col>

					<b-col cols="1" class="sort-handle handle" />

				</b-row>
				
			</b-container>
		</draggable>

		<b-row class="mt-20">
            <b-col cols="3" class="p-0">
                <b-button block 
                          class="draggable-button green" 
                          @click="addEntity" >
                    Добавить
                </b-button>  
            </b-col>
        </b-row>
	</b-container>

</template>
<script>

import '@/assets/styles/admin/tags/sortingEntities.css'

import CustomMultiselect from '../../shared/CustomMultiSelect'

export default {
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        value: [Array, Object],
        options: Array,
        openLink: String,
        apiVersion: {
            type: String,
            default: ""
        }
	},
	computed: {
		valueTemp: {
			get: function() {
				return this.value;
			},
			set: function(value) {
				this.$emit('update', value);
			}
		}
	},
    methods: {
        deleteEntity: function(index) {
            this.valueTemp.splice(index, 1);
            this.$emit('update', this.valueTemp);
        },

        addEntity: function () {
            this.valueTemp.push(null);
            this.$emit('update', this.valueTemp);
		},
		
		openEntity: function(item) {
			window.open(`${this.openLink}?id=${item.Id}&api-Version=${this.apiVersion}`);
		}
    },
    components: {
        CustomMultiselect
    }

}
</script>